import React, { useState } from "react";
import { ChevronRight, Info } from "lucide-react";
import { Popover, PopoverAnchor, PopoverContent } from "@/components/ui/popover";

// Rows that open a deep-dive window: no resting tint, highlight on hover/tap, right arrow on the far right.
export const TAP_BG = "bg-white";
export const TAP_HOVER_BG = "group-hover:bg-[#e8eff8] group-active:bg-[#e8eff8]";
export const TAP_ROW = "group cursor-pointer transition-colors hover:bg-[#e8eff8] active:bg-[#e8eff8]";
// Arrow cell pinned to the right edge so it stays visible while a wide table scrolls on phones.
export const TAP_ARROW_CELL = `sticky right-0 z-10 w-8 px-2 ${TAP_BG} ${TAP_HOVER_BG} shadow-[-1px_0_0_0_#e2e8f0]`;

export function TapArrow({ className = "", size = "h-4 w-4", testId }) {
  return (
    <ChevronRight aria-hidden data-testid={testId}
      className={`inline-block ${size} shrink-0 text-slate-400 transition-transform group-hover:translate-x-0.5 group-hover:text-slate-600 ${className}`} />
  );
}

// ⓘ at the top-left of a card with tappable rows: tip shows on hover (mouse) or tap.
export function TapInfo({ tip, testId }) {
  const [open, setOpen] = useState(false);
  const mouse = (fn) => (e) => { if (e.pointerType === "mouse") fn(); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverAnchor asChild>
        <span role="button" tabIndex={0} aria-label={tip} data-testid={testId}
          onClick={(e) => { e.stopPropagation(); setOpen(true); }}
          onPointerEnter={mouse(() => setOpen(true))} onPointerLeave={mouse(() => setOpen(false))}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); setOpen((o) => !o); } }}
          className="inline-flex h-8 w-8 shrink-0 cursor-help items-center justify-center rounded-full text-orange-500 transition-colors hover:text-orange-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-300">
          <Info className="h-8 w-8" />
        </span>
      </PopoverAnchor>
      <PopoverContent side="top" className="w-auto max-w-[240px] px-3 py-2 text-xs font-medium normal-case tracking-normal text-slate-600"
        onOpenAutoFocus={(e) => e.preventDefault()} data-testid={testId ? `${testId}-tip` : undefined}>
        {tip}
      </PopoverContent>
    </Popover>
  );
}
